import {
    AccountSubtype,
    AccountType,
} from "@common/constants/domains/accounting/accounts";
import { getAccountClassForType } from "@common/constants/domains/accounting/helpers";
import { Account } from "@common/types/domains/accounting/account";
import type { CreateAccountRequest } from "./AccountCombobox.types";

export const isAccountTypeAllowed = (
    type: AccountType,
    allowedAccountTypes?: AccountType[],
) =>
    !allowedAccountTypes ||
    allowedAccountTypes.length === 0 ||
    allowedAccountTypes.includes(type);

const getAvailableClassifications = (allowedAccountTypes?: AccountType[]) =>
    allowedAccountTypes && allowedAccountTypes.length > 0
        ? Array.from(new Set(allowedAccountTypes.map(getAccountClassForType)))
        : undefined;

export function buildCreateAccountRequest({
    accountName,
    selectedAccount,
    allowedAccountTypes,
}: {
    accountName: string;
    selectedAccount?: Account;
    allowedAccountTypes?: AccountType[];
}): CreateAccountRequest {
    const availableClassifications =
        getAvailableClassifications(allowedAccountTypes);
    if (
        selectedAccount &&
        isAccountTypeAllowed(selectedAccount.type, allowedAccountTypes)
    ) {
        return {
            accountName,
            accountType: selectedAccount.type,
            accountSubtype: selectedAccount.subtype,
            availableClassifications,
        };
    }
    return {
        accountName,
        accountType: allowedAccountTypes?.[0] ?? AccountType.cash,
        accountSubtype: AccountSubtype.cashOnHand,
        availableClassifications,
    };
}
